import type { ExpectedExpense, RepairEstimatePricingSnapshot } from '@otw/models'
import { sortRepairEstimateSnapshots } from '@otw/models/expenses'

export const findExpectedByEstimatePath = (
  expectedExpenses: ExpectedExpense[],
  storagePath: string,
): ExpectedExpense | undefined =>
  expectedExpenses.find(item => item.sourceRepairEstimateStoragePath === storagePath)

export const findExpectedByRepairTruckId = (
  expectedExpenses: ExpectedExpense[],
  repairTruckId: string,
): ExpectedExpense | undefined =>
  findLatestExpectedByRepairTruckId(expectedExpenses, repairTruckId)

export const findExpectedExpensesByRepairTruckId = (
  expectedExpenses: ExpectedExpense[],
  repairTruckId: string,
): ExpectedExpense[] =>
  expectedExpenses.filter(item => item.repairTruckId === repairTruckId)

export const sortExpectedExpensesByCreatedAt = (
  expectedExpenses: ExpectedExpense[],
): ExpectedExpense[] => sortRepairEstimateSnapshots(expectedExpenses)

export const findLatestExpectedByRepairTruckId = (
  expectedExpenses: ExpectedExpense[],
  repairTruckId: string,
): ExpectedExpense | undefined => {
  const sorted = sortExpectedExpensesByCreatedAt(
    findExpectedExpensesByRepairTruckId(expectedExpenses, repairTruckId),
  )
  return sorted[sorted.length - 1]
}

export const toRepairEstimateSnapshot = (
  expected: ExpectedExpense,
  label?: string,
): RepairEstimatePricingSnapshot => ({
  id: expected.id,
  label,
  date: expected.date,
  amount: expected.amount,
  repairPartsAmount: expected.repairPartsAmount,
  repairLaborAmount: expected.repairLaborAmount,
  repairFeesAmount: expected.repairFeesAmount,
  repairTaxAmount: expected.repairTaxAmount,
  lineItems: expected.lineItems,
  sourceRepairEstimateStoragePath: expected.sourceRepairEstimateStoragePath,
  attachmentURL: expected.attachmentURLs?.[0] || expected.attachmentURL,
  reviewStatus: expected.reviewStatus,
})

export const labelRepairEstimateSnapshots = (
  expectedExpenses: ExpectedExpense[],
): RepairEstimatePricingSnapshot[] =>
  sortExpectedExpensesByCreatedAt(expectedExpenses).map((expected, index, all) =>
    toRepairEstimateSnapshot(
      expected,
      all.length > 1 ? `Estimate ${index + 1}` : 'Estimate',
    ),
  )
